import React, { FC, Fragment } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { useLocation, useNavigate } from 'react-router-dom';
import RequestStatusTag from 'components/base/request-status-tag';

import usePrepTeamRequestContext from 'contexts/kitchen/prep-team-request.context/context';
import { PrepRequestType } from 'models/prep-request.model';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { formatCurrency, formatRequestDate } from 'utils/functions';

type Props = {
  request: PrepRequestType;
};

const PrepRequestCard: FC<Props> = ({ request }) => {
  const orderCode = request.id;
  const { setItemRequestToEdit } = usePrepTeamRequestContext();
  const router = useNavigate();
  const { pathname } = useLocation();
  const type = pathname.includes('kitchen') ? 'kitchen' : 'prep';

  const viewRequest = () => {
    const parentRoutes = {
      prep: MAIN_STORE_ROUTE_KEYS.PREP_REQUESTS,
      kitchen: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_PREP_TEAM_REQUESTS
    };

    setItemRequestToEdit(request);

    const viewUrl: Partial<Record<ENUM_REQUEST_STATUS, string>> = {
      [ENUM_REQUEST_STATUS.REJECTED]: `${parentRoutes[type]}/update-rejected/${orderCode}`,
      [ENUM_REQUEST_STATUS.RECEIVED]: `${parentRoutes[type]}/receive-items/${orderCode}`,
      [ENUM_REQUEST_STATUS.REVIEWED]: `${parentRoutes[type]}/completed/${orderCode}`,
      [ENUM_REQUEST_STATUS.SENT]: `${parentRoutes[type]}/receive-items/${orderCode}`
    };
    router(viewUrl[request.status] || `${parentRoutes[type]}/update/${orderCode}`);
  };

  return (
    <Fragment>
      <div className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2 w-full cursor-pointer'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium text-base cursor-pointer'>#{request.code}</h4>
            <RequestStatusTag status={request.status} />
          </div>

          <div className='p-3 text-xs'>
            {request?.items?.map((item, i) => (
              <div key={i} className='flex  items-center '>
                <p className='font-[500]'>{item.ingredient.name} </p>
                <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px] rounded-full' />
                <p className=' text-gray-5'>
                  {item.quantity_requested} {item.ingredient.unit_type || 'portions'} (
                  <span>
                    {formatCurrency(
                      Number(item.quantity_requested) * Number(item.ingredient.min_vendor_price)
                    )}
                  </span>
                  )
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <p>Created {formatRequestDate(request.created_at)}</p>

          <Button className='text-xs' color='primary' variant='link' onClick={() => viewRequest()}>
            See all
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default PrepRequestCard;
